import { render, staticRenderFns } from "./WithdrawTable.vue?vue&type=template&id=88a5b3f6&scoped=true&"
import script from "./WithdrawTable.vue?vue&type=script&lang=js&"
export * from "./WithdrawTable.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawTable.vue?vue&type=style&index=0&id=88a5b3f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a5b3f6",
  null
  
)

export default component.exports